import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appHeaderSelector]',
})
export class HeaderContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
